"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Steps_1 = require("./Steps");
var StepsData_1 = __importDefault(require("./StepsData"));
var spaui_1 = require("@tencent/spaui");
var spaui_utils_1 = require("@tencent/spaui-utils");
/**
 * 默认 icon
 */
/* 圆形背景的对勾 */
var IconHook = function IconHook(props) {
  var className = props.className,
    size = props.size;
  return react_1["default"].createElement("svg", {
    width: size,
    height: size,
    className: (0, classnames_1["default"])('icon', className),
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, react_1["default"].createElement("circle", {
    cx: "8",
    cy: "8",
    r: "8",
    fill: "currentColor"
  }), react_1["default"].createElement("path", {
    d: "M5 7.33333L7.4 10L11 6",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
/* 圆形背景的点点点 */
var IconIng = function IconIng(props) {
  var className = props.className,
    size = props.size;
  return react_1["default"].createElement("svg", {
    className: (0, classnames_1["default"])('icon', className),
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, react_1["default"].createElement("circle", {
    cx: "8",
    cy: "8",
    r: "8",
    fill: "currentColor"
  }), react_1["default"].createElement("circle", {
    cx: "8",
    cy: "8",
    r: "1",
    fill: "#fff"
  }), react_1["default"].createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1",
    fill: "#fff"
  }), react_1["default"].createElement("circle", {
    cx: "5",
    cy: "8",
    r: "1",
    fill: "#fff"
  }));
};
var StepsPanel = function StepsPanel(props, ref) {
  var label = props.label,
    desc = props.desc,
    _a = props.value,
    value = _a === void 0 ? 0 : _a,
    _b = props.StepsDataComponent,
    StepsDataComponent = _b === void 0 ? StepsData_1["default"] : _b,
    // eslint-disable-line
    direction = props.direction,
    _c = props.iconSet,
    iconSet = _c === void 0 ? {} : _c,
    IconComponent = props.IconComponent,
    // eslint-disable-line
    _d = props.lineStyleSet,
    // eslint-disable-line
    lineStyleSet = _d === void 0 ? {} : _d,
    labelProps = props.labelProps,
    descProps = props.descProps,
    total = props.total,
    index = props.index,
    infoClassName = props.infoClassName,
    restProps = __rest(props, ["label", "desc", "value", "StepsDataComponent", "direction", "iconSet", "IconComponent", "lineStyleSet", "labelProps", "descProps", "total", "index", "infoClassName"]);
  var status = props.status;
  var current = (0, react_1.useContext)(Steps_1.StepsContext);
  if (!status) {
    if (value < current) {
      status = 'done';
    } else if (value === current) {
      status = 'doing';
    } else {
      status = 'default';
    }
  }
  var lineStyle = lineStyleSet[status];
  var icons = __assign({
    done: react_1["default"].createElement(IconHook, {
      className: "odc-steps-icon",
      size: 16
    }),
    doing: react_1["default"].createElement(IconIng, {
      className: "odc-steps-icon odc-steps-icon-blue",
      size: 16
    }),
    "default": react_1["default"].createElement(IconIng, {
      className: "odc-steps-icon",
      size: 16
    }),
    error: react_1["default"].createElement(spaui_1.Icon, {
      className: "odc-steps-icon odc-steps-icon-red",
      name: "exclamation-filled"
    })
  }, iconSet);
  var stepIcon = icons[status];
  if (IconComponent && (0, spaui_utils_1.isFunction)(IconComponent)) {
    stepIcon = react_1["default"].createElement(IconComponent, __assign({
      status: status
    }, props));
  }
  return react_1["default"].createElement(StepsDataComponent, __assign({
    ref: ref,
    label: label,
    desc: desc,
    icon: stepIcon,
    active: status === 'doing',
    value: value,
    current: current,
    status: status,
    direction: direction,
    labelProps: labelProps,
    descProps: descProps,
    total: total,
    index: index,
    infoClassName: infoClassName,
    lineStyle: lineStyle
  }, restProps));
};
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(StepsPanel));